import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Header, Footer, LoadIndicator} from '../../components';
import {connect} from 'react-redux';
import styles from './CmsPage.pcss';
import {withRouter} from 'react-router';
import PagesApi from '../../api/PagesApi';
import {generateRoutePath} from 'epic-common/src/route';

const mapStateToProps = state => ({
    messages: state.get('localization').get('messageProperties'),
    userState: state.get('user').toJS(),
    influencerState: state.get('influencer').toJS(),
    configState: state.get('config').toJS()
});

const CmsPage = props => {
    const {messages, userState, configState, influencerState} = props;
    const {affiliateAccount} = influencerState;
    const {accountInfo} = userState;
    const {epicFooter} = configState;

    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState('');

    async function fetchPage(slug, locale) {
        setLoading(true);

        try {
            const response = await PagesApi.getPage({slug, locale});

            if (response.data) {
                setLoading(false);
                setContent(response.data.content);
            } else {
                throw new Error('No data retrieved');
            }
        } catch (e) {
            const url = generateRoutePath('/404');
            props.history.push(url);
        }
    }

    useEffect(() => {
        const slug = props.match.params.slug;
        const locale = props.match.params.locale;

        fetchPage(slug, locale);
    }, [props.match.params.slug]);

    return (
        <div>
            <Header
                messages={messages}
                affiliateAccount={affiliateAccount}
                accountInfo={accountInfo}
                configState={configState}
            />
            <div className={styles.container}>
                <div className={styles.content}>
                    <LoadIndicator loading={loading} messages={messages}>
                        <div className={styles.body} dangerouslySetInnerHTML={{__html: content}} />
                    </LoadIndicator>
                </div>
            </div>
            <Footer content={epicFooter} messages={messages} accountInfo={accountInfo} />
        </div>
    );
};

CmsPage.propTypes = {
    messages: PropTypes.object,
    getOverviewData: PropTypes.func,
    overviewState: PropTypes.object,
    influencerState: PropTypes.object,
    userState: PropTypes.object,
    configState: PropTypes.object,
    match: PropTypes.object,
    history: PropTypes.object
};

export default withRouter(connect(mapStateToProps)(CmsPage));
